/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'glassthickness-plus': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: `<defs><clipPath id="svgicon_glassthickness-plus_a"><path pid="0" d="M0 0h22v22H0z"/></clipPath></defs><g _fill="currentColor" clip-path="url(#svgicon_glassthickness-plus_a)"><path pid="1" d="M9.5 0h3v22h-3z"/><path pid="2" d="M22 9.5v3H0v-3z"/></g>`
  }
})
/* tslint:enable */
